/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { CountryCode } from '../models/CountryCode';
import type { SemiStaticData } from '../models/SemiStaticData';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SemiStaticDataService {
    /**
     * Get Semi Static Data
     * Get semi static data.
     * @param country
     * @returns SemiStaticData Successful Response
     * @throws ApiError
     */
    public static getSemiStaticDataSemiStaticDataGet(
        country: CountryCode = CountryCode.IT,
    ): CancelablePromise<SemiStaticData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/semi_static_data/',
            query: {
                'country': country,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Semi Static Data
     * Get semi static data.
     * @returns SemiStaticData Successful Response
     * @throws ApiError
     */
    public static getSemiStaticDataSemiStaticDataV2Get(): CancelablePromise<SemiStaticData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/semi_static_data/v2',
        });
    }
}
